/* @flow */

import React from 'react';
import UploadFileButton from './UploadFileButton';
import { withRouter } from 'react-router-dom';
import ConfirmDeleteButton from 'shared/components/ConfirmDeleteButton';

type Props = {
  folder: BucketFolder,
  resourcesCount: number,
  history: Object,
  onUpload: (folder: BucketFolder, files: FileList) => void,
  onRemove: (folder: BucketFolder) => void,
  isRemoving: boolean,
};

const FolderItem = ({
  folder,
  resourcesCount,
  history,
  onUpload,
  onRemove,
  isRemoving,
}: Props) => {
  const uploadFiles = files => onUpload(folder, files);
  const navigateTo = () => history.push(`folders/${folder.id}`);
  const remove = () => onRemove(folder);

  const deleteModalContent = `
    Êtes-vous sûr(e) de vouloir supprimer ce dossier
    et ses ${resourcesCount} ressource(s) ?
  `;

  return (
    <div className="ui card" onClick={navigateTo} style={{ cursor: 'pointer' }}>
      <div className="content">
        <div className="header">{folder.name}</div>
      </div>
      <div className="content">
        <div className="two ui buttons">
          <UploadFileButton
            folder={folder}
            onUpload={uploadFiles}
            className="ui basic primary button"
          />
          <ConfirmDeleteButton
            content="Supprimer"
            modalContent={deleteModalContent}
            className="basic red"
            isLoading={isRemoving}
            onConfirm={remove}
          />
        </div>
      </div>
      <div className="extra content">
        {`${resourcesCount} Ressource(s)`}
      </div>
    </div>
  );
};

export default withRouter(FolderItem);



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Folders/components/FolderItem.js